import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { MailRibbonControlId, MailRibbonTabId } from 'owa-ribbon-ids';
import type { RibbonControlId } from 'owa-ribbon-ids';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';
import * as ControlDef from './mlrInsertTabControlDefinitions';
import * as SharedControlDef from '../../sharedControls/sharedControlsDef';

/**
 * This function supplies a mapping from RibbonControlId to their respective control definition function.
 * For any new control in a tab, be sure to update the mapping below.
 * Note: This function should *not* have any logic regarding showing/hiding.
 *       That should be in shouldShowRibbonControl.ts instead.
 */
export const getMLRInsertTabControlDefinition = computedFn(
    (controlId: RibbonControlId, props: RibbonControlDefinitionProps): RibbonControlProps => {
        const viewState: ComposeViewState | undefined = props.popoutComposeViewState;

        switch (controlId) {
            case MailRibbonControlId.AttachFile:
                return SharedControlDef.getAttachFileControl(
                    props.attachmentPickers!.addFilesAsAttachments!, // Cannot be undefined, because shouldShowRibbonControl checks for this
                    viewState,
                    MailRibbonTabId.Tab_Insert
                );
            case MailRibbonControlId.Poll:
                return ControlDef.getPollControl(viewState);
            case MailRibbonControlId.AttachSig:
                return SharedControlDef.getAttachSigControl(viewState, MailRibbonTabId.Tab_Insert);
            case MailRibbonControlId.Table:
                return SharedControlDef.getTableControl(viewState, props.targetWindow);
            case MailRibbonControlId.Pictures:
                return SharedControlDef.getPicturesControl(
                    viewState,
                    props.attachmentPickers!.addImagesInline!
                );
            case MailRibbonControlId.Emojis:
                return SharedControlDef.getEmojisControl(viewState, props.targetWindow);
            case MailRibbonControlId.ShowLinkDialog:
                return SharedControlDef.getLinkControl(viewState, props.targetWindow);
            default:
                throw new Error(
                    'Unknown control: ' +
                        controlId +
                        ' searched for in getMLRInsertTabControlDefinition'
                );
        }
    }
);
